// Authentication action types
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REGISTER = 'AUTH_REGISTER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_RESET_PASSWORD = 'AUTH_RESET_PASSWORD';
export const AUTH_CONNECT_FACEBOOK = 'AUTH_CONNECT_FACEBOOK';
export const AUTH_CONNECT_LINE = 'AUTH_CONNECT_LINE';

// Action creators
export const login = (userData) => {
  // In a real app, this would make an API call to authenticate
  return {
    type: AUTH_LOGIN,
    payload: userData
  };
};

export const logout = () => {
  // Clear any auth tokens from localStorage
  localStorage.removeItem('ruaysure-auth-token');
  localStorage.removeItem('ruaysure-user');
  
  return {
    type: AUTH_LOGOUT
  };
};

export const register = (userData) => {
  // In a real app, this would make an API call to register
  return {
    type: AUTH_REGISTER,
    payload: userData
  };
};

export const setAuthError = (error) => {
  return {
    type: AUTH_ERROR,
    payload: error
  };
};

export const setAuthLoading = (isLoading) => {
  return {
    type: AUTH_LOADING,
    payload: isLoading
  };
};

export const resetPassword = (email) => {
  // In a real app, this would make an API call to reset password
  return {
    type: AUTH_RESET_PASSWORD,
    payload: email
  };
};

export const connectFacebook = (facebookData) => {
  return {
    type: AUTH_CONNECT_FACEBOOK,
    payload: facebookData
  };
};

export const connectLine = (lineData) => {
  return {
    type: AUTH_CONNECT_LINE,
    payload: lineData
  };
};

// Thunk action creators for async operations
export const loginUser = (email, password) => {
  return async (dispatch) => {
    dispatch(setAuthLoading(true));
    
    try {
      // Simulate API call
      // In a real app, replace with actual API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Mock successful login
      const userData = {
        id: 'user123',
        email: email,
        name: 'Test User',
        role: 'client',
        token: 'mock-jwt-token'
      };
      
      // Store token in localStorage
      localStorage.setItem('ruaysure-auth-token', userData.token);
      localStorage.setItem('ruaysure-user', JSON.stringify(userData));
      
      dispatch(login(userData));
    } catch (error) {
      dispatch(setAuthError('Invalid email or password'));
    } finally {
      dispatch(setAuthLoading(false));
    }
  };
};

export const registerUser = (userData) => {
  return async (dispatch) => {
    dispatch(setAuthLoading(true));
    
    try {
      // Simulate API call
      // In a real app, replace with actual API call
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Mock successful registration
      const newUser = {
        id: 'user' + Math.floor(Math.random() * 1000),
        email: userData.email,
        name: userData.firstName + ' ' + userData.lastName,
        role: 'client',
        token: 'mock-jwt-token'
      };
      
      // Store token in localStorage
      localStorage.setItem('ruaysure-auth-token', newUser.token);
      localStorage.setItem('ruaysure-user', JSON.stringify(newUser));
      
      dispatch(register(newUser));
    } catch (error) {
      dispatch(setAuthError('Registration failed. Please try again.'));
    } finally {
      dispatch(setAuthLoading(false));
    }
  };
};

export const resetUserPassword = (email) => {
  return async (dispatch) => {
    dispatch(setAuthLoading(true));
    
    try {
      // Simulate API call
      // In a real app, replace with actual API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      dispatch(resetPassword(email));
      return true;
    } catch (error) {
      dispatch(setAuthError('Password reset failed. Please try again.'));
      return false;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };
};

export const loginWithFacebook = () => {
  return async (dispatch) => {
    dispatch(setAuthLoading(true));
    
    try {
      // Simulate Facebook SDK login
      // In a real app, replace with actual Facebook SDK integration
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Mock successful Facebook login
      const facebookData = {
        id: 'fb123456789',
        name: 'Facebook User',
        email: 'facebook@example.com',
        token: 'mock-fb-token',
        role: 'client'
      };
      
      // Store token in localStorage
      localStorage.setItem('ruaysure-auth-token', facebookData.token);
      localStorage.setItem('ruaysure-user', JSON.stringify(facebookData));
      
      dispatch(connectFacebook(facebookData));
      dispatch(login(facebookData));
    } catch (error) {
      dispatch(setAuthError('Facebook login failed. Please try again.'));
    } finally {
      dispatch(setAuthLoading(false));
    }
  };
};

export const loginWithLine = () => {
  return async (dispatch) => {
    dispatch(setAuthLoading(true));
    
    try {
      // Simulate LINE login
      // In a real app, replace with actual LINE API integration
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Mock successful LINE login
      const lineData = {
        id: 'line123456789',
        name: 'LINE User',
        email: 'line@example.com',
        token: 'mock-line-token',
        role: 'client'
      };
      
      // Store token in localStorage
      localStorage.setItem('ruaysure-auth-token', lineData.token);
      localStorage.setItem('ruaysure-user', JSON.stringify(lineData));
      
      dispatch(connectLine(lineData));
      dispatch(login(lineData));
    } catch (error) {
      dispatch(setAuthError('LINE login failed. Please try again.'));
    } finally {
      dispatch(setAuthLoading(false));
    }
  };
};
